var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MiCalendar-container"},[_c('div',{attrs:{"id":_vm.calendarId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }